import type { DataMode } from '../../shared/contracts';
import { hideDemoBadges } from '../lib/flags';

const PILL = 'text-[10px] font-medium uppercase tracking-wider';

/**
 * Per-pane data-mode badge. `live`/`empty`/`stale`/`error` are real production
 * states and always show; only the `mock` ("Demo") tell is hidden in presentation
 * mode (VITE_HIDE_DEMO_BADGES) — and `mock` never occurs in production.
 */
export function LiveBadge({ mode }: { mode: DataMode }) {
  if (mode === 'live') {
    return (
      <span className={`inline-flex items-center gap-1 ${PILL} text-brand-green`}>
        <span className="h-1.5 w-1.5 rounded-full bg-brand-green animate-breathe" />
        Live
      </span>
    );
  }
  if (mode === 'stale') {
    return (
      <span className={`${PILL} text-brand-amber`} title="Cachet data (kilden svarede ikke)">
        Cache
      </span>
    );
  }
  if (mode === 'error') {
    return (
      <span className={`${PILL} text-brand-error`} title="Kilden er ikke tilgængelig">
        Fejl
      </span>
    );
  }
  if (mode === 'empty') {
    return <span className={`${PILL} text-brand-dark/40`}>Ingen data</span>;
  }
  // mock — the only demo tell; hidden in presentation mode.
  if (hideDemoBadges()) return null;
  return <span className={`${PILL} text-brand-amber`}>Demo</span>;
}
